// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Textarea_textareaContainer__aZC7\\+ {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.Textarea_textareaContainer__aZC7\\+.Textarea_disabled__Qwrnh {
  opacity: 0.6;
  cursor: not-allowed;
}

.Textarea_label__dwbnR {
  font-weight: 500;
  font-size: var(--font-size-smaller);
  color: var(--color-text-subtle);
  margin-bottom: 0.375rem;
}

.Textarea_textarea__1vXz0 {
  width: 100%;
  padding: 0.5rem 0.875rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-default, 0.25rem);
  transition: border-color 0.15s;
  resize: vertical;
  min-height: 5rem;
  font-family: inherit;
  line-height: 1.4;
}
.Textarea_textarea__1vXz0:hover {
  border-color: var(--color-border-hover, var(--color-border));
}
.Textarea_textarea__1vXz0:focus, .Textarea_textarea__1vXz0:focus-visible {
  outline: none;
  border-color: var(--color-primary);
}
.Textarea_textarea__1vXz0::placeholder {
  color: var(--color-text-subtle);
  font-weight: 400;
}
.Textarea_textarea__1vXz0:disabled {
  background-color: var(--color-surface-darker, #f3f4f6);
  cursor: not-allowed;
}

.Textarea_required__LufDK {
  color: var(--color-destructive, #e53e3e);
  margin-left: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Textarea/Textarea.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;EACA,mBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,mCAAA;EACA,+BAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,wBAAA;EACA,gCAAA;EACA,qCAAA;EACA,6CAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAAF;AAEE;EACE,4DAAA;AAAJ;AAGE;EACE,aAAA;EACA,kCAAA;AADJ;AAIE;EACE,+BAAA;EACA,gBAAA;AAFJ;AAKE;EACE,sDAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,wCAAA;EACA,oBAAA;AAJF","sourcesContent":[".textareaContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  &.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.label {\n  font-weight: 500;\n  font-size: var(--font-size-smaller);\n  color: var(--color-text-subtle);\n  margin-bottom: 0.375rem;\n}\n\n.textarea {\n  width: 100%;\n  padding: 0.5rem 0.875rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-default, 0.25rem);\n  transition: border-color 0.15s;\n  resize: vertical;\n  min-height: 5rem;\n  font-family: inherit;\n  line-height: 1.4;\n  \n  &:hover {\n    border-color: var(--color-border-hover, var(--color-border));\n  }\n\n  &:focus, &:focus-visible {\n    outline: none;\n    border-color: var(--color-primary);\n  }\n\n  &::placeholder {\n    color: var(--color-text-subtle);\n    font-weight: 400;\n  }\n\n  &:disabled {\n    background-color: var(--color-surface-darker, #f3f4f6);\n    cursor: not-allowed;\n  }\n}\n\n.required {\n  color: var(--color-destructive, #e53e3e);\n  margin-left: 0.25rem;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textareaContainer": `Textarea_textareaContainer__aZC7+`,
	"disabled": `Textarea_disabled__Qwrnh`,
	"label": `Textarea_label__dwbnR`,
	"textarea": `Textarea_textarea__1vXz0`,
	"required": `Textarea_required__LufDK`
};
export default ___CSS_LOADER_EXPORT___;
